import React, { useState, useEffect } from "react";

const AdminSites = () => {
  const [sites, setSites] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [formData, setFormData] = useState({
    site_name: "",
    site_location: "",
    site_image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      site_image: e.target.files[0], // Store the selected file
    }));
  };

  const handleAddSite = async (e) => {
    e.preventDefault();

    const form = new FormData();
    for (let key in formData) {
      form.append(key, formData[key]);
    }

    try {
      const response = await fetch("https://api.swalokgroup.com/api/add-site", {
        method: "POST",
        body: form,
      });
      if (response.ok) {
        setResponseMessage("Site Listed Successfully");
        setTimeout(() => {
          setResponseMessage("");
          window.location.reload();
        }, 1000);
      } else {
        setResponseMessage("Failed to list site. Try again later.");
        setTimeout(() => {
          setResponseMessage("");
        }, 1000);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Fetch sites data from the backend when the component is mounted
  useEffect(() => {
    const fetchSites = async () => {
      try {
        const response = await fetch("https://api.swalokgroup.com/api/get-sites");
        const data = await response.json();

        if (response.ok) {
          setSites(data);
        } else {
          console.error("Failed to fetch sites:", data);
        }
      } catch (error) {
        console.error("Error while fetching sites:", error);
      }
    };

    fetchSites();
  }, []); // Empty dependency array means it runs once when the component mounts

  // delete listed site
  const handleDeleteSite = async (siteId) => {
    try {
      const response = await fetch(
        `https://api.swalokgroup.com/api/delete-site?siteId=${siteId}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete site");
      }

      setSites((prevSites) => prevSites.filter((s) => s.id !== siteId));
      alert("Site Deleted Successfully");
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <section className="container py-5 px-4">
        <div className="sec-subheading">
          <hr />
          <span>List Sites</span>
          <hr />
        </div>

        <div className="profile-area-inner mt-4">
          <p className="profile-heading">Add New Site</p>

          <form className="row g-3 py-4 px-4" onSubmit={handleAddSite}>
            <div className="col-md-4">
              <label htmlFor="Site Name" className="form-label text-muted">
                Site Name
              </label>
              <input
                type="text"
                className="form-input"
                name="site_name"
                value={formData.site_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="Site Location" className="form-label text-muted">
                Site Location
              </label>
              <input
                type="text"
                className="form-input"
                name="site_location"
                value={formData.site_location}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="Site Image" className="form-label text-muted">
                Upload Site Image
              </label>
              <input
                type="file"
                className="form-input"
                name="site_image"
                onChange={handleFileChange}
                required
              />
            </div>

            <div className="col-12 my-4 text-end">
              <button type="submit" className="admin-btn py-2 px-3 rounded">
                Submit
              </button>
            </div>
          </form>
          {/* form ends */}
        </div>

        <div className="row my-4">
          {sites.length > 0 ? (
            sites.map((site) => (
              <div key={site.id} className="col-lg-4 col-md-6 col-12 my-2">
                <div className="offer-area-outer">
                  <img
                    src={`https://api.swalokgroup.com/uploads/${site.site_image}`}
                    className="img-fluid"
                    style={{ height: "16em" }}
                    alt="Exclusive Offers"
                  />
                  <div className="offer-area">
                    <p className="fw-bold">{site.site_name}</p>
                    <p className="text-muted">Location: {site.site_location}</p>
                    <button
                      className="admin-btn bg-danger rounded px-2 py-2"
                      onClick={() => handleDeleteSite(site.id)}
                    >
                      Delete Site <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No sites available.</p>
          )}
        </div>
        {/* inner row ends */}
        {responseMessage && (
          <div className="response-message d-flex justify-content-between">
            <p className="my-0 mx-auto">{responseMessage}</p>
            <p
              className="my-0 cursor-pointer"
              onClick={() => setResponseMessage(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </p>
          </div>
        )}
      </section>
    </>
  );
};

export default AdminSites;
